import { ManageJobOffersTranslation } from 'locales/de/pages/Jobmarket/manageJobOffers';

const en: ManageJobOffersTranslation = {
  alerts: {
    saveSuccessful: 'The job offer was successfully updated.',
    saveFailed: 'The job offer could not be updated.',
    deleteSuccessful: 'The job offer was successfully deleted.',
    deleteFailed: 'The job offer could not be deleted.',
    errorLoading: 'The job offer could not be loaded.'
  },
  createNew: 'New Job Offer',
  title: 'Title',
  displayPeriod: 'Display period',
  periodStart: 'Start date',
  priceCategories: 'Price categories',
  paidCategoriesInformation: 'Paid categories are marked with *',
  detailView: 'Detail view',
  edit: 'Edit offer',
  delete: 'Delete offer',
  jobOfferView: 'Job Offer View',
  deleteConfirm: {
    title: 'Are you sure?',
    message: 'Do you really want to permanently delete this job offer?'
  },
  addPeriod: {
    title: 'Extend display period',
    message: 'Do you want to extend the display period by {{interval}}?',
    messageNoInterval: 'Do you want to extend the display period?'
  },
  deletePeriod: {
    title: 'Delete display period',
    message: 'Do you want to delete the display period?'
  },
  attachementUploadPlaceholder: 'Attachement upload (pdf, doc(x), zip)',
  attachementUploadInfo: 'Maximum upload size: {{size}}',
  factors: {
    day: '{{duration}} day',
    day_plural: '{{duration}} days',
    week: '{{duration}} week',
    week_plural: '{{duration}} weeks',
    month: '{{duration}} month',
    month_plural: '{{duration}} months',
    year: '{{duration}} year',
    year_plural: '{{duration}} years'
  },
  paid: 'Paid',
  externalLink: 'External link',
  externalLinkTooltip:
    '(Optional) This link will be used instead of the email to submit the application.'
};

export default en;
